import { map } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { Command, MultiselectCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { ControlDataExportCommand } from '../../../rent/command/control-data-export.command';
import { ControlDataFormService } from '../../../rent/service/data/control-data-form.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { ControlDataRegenerateFormComponent } from '../../../rent/component/control-data-regenerate-form/control-data-regenerate-form.component';

@Injectable()
export class RegenerateControlDataCommandHandler implements ICommandHandler {
  constructor(
    private _service: ControlDataFormService,
    private _nativeWindow: NativeWindowService,
    private _injector: Injector,
    private _actionService: ActionWindowService
  ) {}

  private items: any;

  canExecute(command: Command): boolean {
    if (command instanceof MultiselectCommand) {
      return command.id === ControlDataExportCommand.regenerateControlData && command.itemsSource.length > 0;
    }
    return false;
  }

  execute(command: Command): Observable<boolean> {
    if (command instanceof MultiselectCommand) {
      if (command.id === ControlDataExportCommand.regenerateControlData) {
      }
      this.items = command.items.map(item => item.id);
      return this._actionService.open(ControlDataRegenerateFormComponent, this._injector, null, this.items, false).pipe(
        map(res => {
          if (res) {
            return true;
          }
          return false;
        })
      );
    }
  }
}
